import apiEndPoints from 'common/apiEndPoints';
import { performRequestFourth } from 'common/apiHandler';
import { getTenantDetails } from 'utils/utils';

export const getGlobalDropdown = (
  practice_area_id = '',
  module = '',
  keyword = '',
  case_id = '',
  is_lead = false,
  page = 1,
  limit = 15,
  sort_order = 'alphabet_ascending',
  lead_stage_status = '',
  data,
  in_lead = false,
  contact_status = '',
  contact_type = '',
  is_court_location = false,
  excludeFromLoading = false
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestFourth(
    apiEndPoints.methodType.POST,
    `${
      apiEndPoints.globalDropdown
    }?tenant_id=${tenantId}&tenant_sk=${tenantSk}&page=${page}&limit=${limit}&module=${module}&keyword=${keyword}&is_lead=${is_lead}${
      in_lead ? `&in_lead=${in_lead}` : ''
    }${contact_status ? `&contact_status=${contact_status}` : ''}${sort_order ? `&sort_order=${sort_order}` : ''}${
      lead_stage_status ? `&lead_stage_status=${lead_stage_status}` : ''
    }${case_id ? `&case_id=${case_id}` : ''}${practice_area_id ? `&practice_area_id=${practice_area_id}` : ''}${
      contact_type ? `&contact_type=${contact_type}` : ''
    }${is_court_location ? `&is_court_location=${is_court_location}` : ''}`,
    data,
    null,
    true,
    excludeFromLoading
  );
};
